import { FC, useEffect } from 'react'

import { BKBNThemeWrapper } from 'components/common/BKBNThemeWrapper'
import { CreativeUploadWizardContext } from './CreativeUploadWizard.context'
import { CreativeUploadWizardController } from './CreativeUploadWizard.controller'
import { DynamicFlowProvider } from '../../DynamicFlow'
import { useClearAssignmentVisuals } from 'dataQueries'
import { useParams } from 'react-router-dom'

/**
 * Module providing CTs new flow for uploading visuals in shape of fullscreen stepped flow.  
 * Assignment id is sourced from address path param.  
 * @example <CreativeUploadWizard />
 */
export const CreativeUploadWizard: FC = () => {
  const { id } = useParams<{ id?: string }>()

  const clearVisuals = useClearAssignmentVisuals()

  // Clear bucket from potential stale visuals before attempting new upload
  useEffect(() => {
    if (!id) return

    clearVisuals.mutate({ assignmentId: id })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!id) return null

  return (
    <BKBNThemeWrapper>
      <DynamicFlowProvider>
        <CreativeUploadWizardContext assignmentId={id}>
          <CreativeUploadWizardController />
        </CreativeUploadWizardContext>
      </DynamicFlowProvider>
    </BKBNThemeWrapper>
  )
}
